import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/pages/login'
import Register from '@/pages/register'
import Verify from '@/pages/verify'
import Auth from '@/helpers/auth'
import menu from './menu'
import Profile from '@/pages/profile'
import Course from '@/pages/course'
import CoursePayment from '@/pages/course-payment'
import CourseCongratulation from '@/pages/course-congratulation'
import CourseProcessing from '@/pages/course-processing'

Vue.use(Router)

let base = [
  {
    path: '/',
    name: 'login',
    component: Login,
    beforeEnter: Auth.checkLogged
  },
  {
    path: '/register',
    name: 'register',
    component: Register,
    beforeEnter: Auth.checkLogged
  },
  {
    path: '/verify/:code',
    name: 'verify',
    component: Verify
  },
  {
    path: '/course/:slug',
    name: 'Curso',
    component: Course,
    beforeEnter: Auth.requireAuth
  },
  {
    path: '/payment',
    name: 'Pagar curso',
    component: CoursePayment,
    beforeEnter: Auth.requireAuth
  },
  {
    path: '/congratulation/:courseId',
    name: 'Felicidades',
    component: CourseCongratulation,
    beforeEnter: Auth.requireAuth
  },
  {
    path: '/process',
    name: 'Gracias',
    component: CourseProcessing,
    beforeEnter: Auth.requireAuth
  },
  {
    path: '/me',
    name: 'Mi perfil',
    component: Profile,
    beforeEnter: Auth.requireAuth
  }
]

const routes = base.concat(menu)

export default new Router({
  routes: routes
})



// WEBPACK FOOTER //
// ./src/router/index.js